<template>
    <div>
        <div class="top-content-wrap base-station">
            <div class="header-container">
                <div class="container">
                <div class="row">
                    <div class="col-xs col-lg-12">
                    <div class="header-claim">
                        <div class="claim-title">
                          <h1>
                              Auto verkaufen - bequem und sicher
                          </h1>
                          <span class="sub-title">Lokal in deiner Nähe oder online von zu Hause verkaufen</span>
                        </div>
                        <div class="claim-content">
                          <ul>
                            <li>100 % kostenlos</li>
                            <li>Keine lästigen Anfragen</li>
                            <li>Sofort Geld in bar oder per Blitzüberweisung</li>
                          </ul>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <ContentWidgetForm />
            
            <!-- <Garantie :isOpen="showModal['garantie']" @close="closeModal('garantie')" />
                <DaysModal :isOpen="showModal['days']" @close="closeModal('days')" />
                <LieferungModal :isOpen="showModal['lieferung']" @close="closeModal('lieferung')" />
                <WidgetModal :isOpen="showModal['widget']" @close="closeModal('widget')" /> -->
            </div>
        <Vorteile />
    </div>
    
  </template>
  
  <script>
  import ContentWidgetForm from "./ContentWidgetForm";
//   import Garantie from "./modals/GarantieModal.vue";
//   import DaysModal from "./modals/14DaysModal.vue";
//   import LieferungModal from "./modals/LieferungModal.vue";
//   import WidgetModal from './modals/WidgetModal.vue';
  import Vorteile from './Vorteile.vue';
  import { redirectToEvaluation } from "../services/helpers";
  
  export default {
    name: "Header",
    data() {
      return {
        showModal: {
          garantie: false,
          days: false,
          lieferung: false,
          widget: false,
        },
      }
    },
    components: {
      ContentWidgetForm,
    //   Garantie,
    //   DaysModal,
    //   LieferungModal,
    //   WidgetModal,
      Vorteile
    },
    methods: {
      openModal(modalId) {
        this.showModal[modalId] = true;
      },
      closeModal(modalId) {
        this.showModal[modalId] = false;
      },
      makeRedirect() {        
        redirectToEvaluation(this.$store);
      }
    }
  };
  </script>
  <style lang="scss">
  @import "~@/assets/vars";
  
  a:hover {
    text-decoration: none !important;
  }
  
  body {
    font-family: "Asap", sans-serif !important;
  }
  
  // redesign code
  .top-content-wrap,
  .top-content-wrap * {
    font-family: "Asap", sans-serif;
  
    i {
      font-family: 'font awesome 5 free';
    }
  }
  
  hr {
    border: 0 none;
    background: $border-dark;
    height: 1px;
    width: 100%;
  }
  
  .top-content-wrap.base-station {
    position: relative;
    &:before {
      content:"";
      display:block;
      width: 100%;
      height: 100%;
      position:absolute;
      background-color: rgba($black-variant, .45);
      top:0;
      left:0;
    }

    background-image: url("../assets/base/header-bg-small.jpg");
      background-size: cover;
      background-position: right -60px center;
      position: relative;
      padding-top:35px;
      padding-bottom:35px;

      @include breakpoint(smallmedium) {
        background-position: center;
      }
  
      @include breakpoint(frommediumlarge) {
        background-image: url("../assets/base/header-bg-medium.jpg");
        padding-top:55px;
        padding-bottom:60px;
      }

      @include breakpoint(fromlarge) {
        padding-top:150px;
      }
  
      @include breakpoint(fromgiant) {
        padding-top: 165px;
        padding-bottom: 279px;
        background-image: url("../assets/base/header-bg.jpg");
        background-position: center center;
  
        
      }
  
      @media screen and (min-width:1200px) and (max-height:930px) {
        padding-top:45px;
        padding-bottom:195px;
      }
  
      @media screen and (min-width:1200px) and (max-height:950px) {
        padding-bottom:260px;
      }
  
      @include breakpoint(extralarge) {
        background-position: center;
      }
  
    .header-container {
      position: relative;
      background: none;
      padding:0;

      &:before {
        display:none !important;
      }
  
      .header-claim {
        .claim-title {
          padding-left:0;
            &:before {
              display:none;
            }
            
            @include breakpoint(frommediumlarge) {
                margin-bottom: 34px;
            }
            @include breakpoint(extralarge) {
                margin-bottom: 40px;
            }

            h1 {
                font-size: 27px;
                line-height: 34px;
                font-weight: bold;
                position: relative;
                padding-left:14px;
                color:$white;

                @include breakpoint(fromlarge) {
                  font-size: 50px;
                  line-height: 70px;
                }

                @include breakpoint(fromgiant) {
                  font-size: 60px;
                  line-height: 69px;
                }

                &:before {
                    content:"";
                    display:block;
                    width: 3px;
                    height: 100%;
                    position:absolute;
                    left:0;
                    top:50%;
                    transform: translateY(-50%);
                    background-color: $white;
                }
            }

            .sub-title {
                font-size: 14px;
                line-height: 24px;
                font-weight: bold;
                color:$white;

                @include breakpoint(fromlarge) {
                  font-size: 26px;
                  line-height: 40px;
                  font-weight: normal;
                  padding-left:14px;
                }
            }

            ul {
              font-size: 22px;
              line-height: 44px;
              color: $white;
            }
        }
        .claim-content {
          display:none;

          @include breakpoint(fromlarge) {
            display:block;
            padding-left:14px;
          }
          ul {
            padding-left: 0;

            @media screen and (min-width:1200px) and (max-height:930px) {
              margin-bottom:0;
            }
  
            li {
              font-weight: 600;
              font-size: 15px;
              line-height: 22px;
              padding-left: 25px;
              position: relative;
              margin-bottom: 8px;
              color: $white;
              position: relative;
  
              @include breakpoint(frommediumlarge) {
                font-size: 20px;
                line-height: 30px;
              }
  
  
                &:before {
                    content: "\f00c";
                    font-family: 'Font Awesome 5 Free';
                    font-weight: 700;
                    display: block;
                    color: $green-light;
                    font-size: 18px;
                    position: absolute;
                    left: 0;
                    top: 0;
                    background:none;
                }
            }
          }
        }
      }
    }
  
    section.online-verkaufen-fahrzeugwert {
      padding-top:20px;
      padding-bottom: 30px;
  
      @include breakpoint(frommediumlarge) {
        padding-top: 36px;
        padding-bottom: 60px;
      }
  
      @include breakpoint(fromgiant) {
        padding-top: 76px;
        padding-bottom: 110px;
      }
  
      h2 {
        br {
          display:none;
          @include breakpoint(fromlarge) {
            display:block;
          }
        }
      }
    }
  
    .teaser-wrap-row {
      padding-top: 10px;
  
      @include breakpoint(frommediumlarge) {
        padding-top:23px;
      }
  
      @include breakpoint(fromgiant) {
        padding-top: 35px;
        padding-bottom: 55px;
      }
  
      .teaser-block {
        margin-bottom:23px;
        @include breakpoint(frommediumlarge) {
           margin-bottom:55px;
  
           &:last-of-type {
             margin-bottom:43px;
           }
        }
        @include breakpoint(fromgiant) {
           margin-bottom:0;
  
           &:last-of-type {
             margin-bottom:0;
           }
        }
        br {
          display:none;
          @include breakpoint(frommediumlarge) {
            
            &:nth-of-type(2) {
              display:none;
            }
          }
          @include  breakpoint(extralarge) {
            display:block;
          }
        }
  
        .icon-block {
          margin-bottom: 13px;
  
          @include breakpoint(frommediumlarge) {
              margin-bottom:30px;
          }
  
          img {
            height:76px;
  
            @include breakpoint(frommediumlarge) {
              height:auto;
            }
          }
        }
        .teaser-title {
          
          @include breakpoint(frommediumlarge) {
            padding-bottom: 12px;
          }
        }
      }
    }
  
    .funktioniert-online-verkauf {
      padding-top: 25px;
  
      @include breakpoint(fromgiant) {
        display:block;
        padding-top:0;
      }
      .action-block {
        padding-top:20px;
        margin-bottom:35px;
        @include breakpoint(frommediumlarge) {
          padding-top: 0;
          margin-bottom: 50px;
        }
        @include breakpoint(fromgiant) {
          padding-top: 61px;
          margin-bottom: 75px;
        }
      }
    }
  
    ul.step-list {
      padding: 15px 0 0;
      width: 100%;
  
      @include breakpoint(fromlarge) {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
      }
  
      @include breakpoint(fromgiant) {
        padding: 25px 0 0;
      }
  
      @include breakpoint(extralarge) {
        padding: 25px 50px 0;
      }
  
      li {
        
        width:100%;
        position:relative;
  
        @include breakpoint(fromlarge) {
          width:20%;
          text-align: center;
        }
  
        .step-block {
          display:flex;
          align-items: center;
          margin-bottom:20px;
  
          @include breakpoint(frommediumlarge) {
            margin-bottom:40px;
          }
  
          @include breakpoint(fromlarge) {
            display:block;
            padding:0 10px;
          }
  
          @include breakpoint(fromgiant) {
            margin-bottom:0;
          }
  
          @include breakpoint(full) {
            padding:0;
          }
  
          br {
            display:none;
            @include breakpoint(full) {
              display:block;
            }
          }
  
          img {
            width:75px;
            margin-right:22px;
  
            @include breakpoint(fromlarge) {
              margin-right:0;
            }
  
            @include breakpoint(fromgiant) {
              width:auto;
              
            }
          }
  
          p {
            margin-bottom:0;
            @include breakpoint(fromlarge) {
              font-size:16px;
            }
  
            @include breakpoint(full) {
              font-size: 18px;
              
            }
          }
        }
  
        &:last-of-type {
          &:after {
            display:none;
          }
        }
        
        @include breakpoint(fromlarge) {
          &:after {
            content:"";
            display:block;
            height: 1px;
            background: $border-dark;
            width: 63px;
            position:absolute;
            right:-35px;
            top:40px;
          }
        }
  
        @include breakpoint(fromgiant) {
          &:after {
            top:63px;
          }
        }
        img {       
  
          @include breakpoint(fromgiant) {
            margin-bottom: 26px;
          }
        }
      }
    }
  
    .contact-container {
      background:$light-gray;
      border-radius: 12px;
      margin-top: 35px;
  
      @include breakpoint(frommediumlarge) {
        margin-top: 55px;
      }
  
      @include breakpoint(fromgiant) {
        background:transparent;
        border-radius:0;
        margin-top:0;
      }
    }
  
    .contact-block {
      background: $light-gray;
      border-radius: 12px;
      padding: 26px 0 34px;
      text-align:center;
  
      @include breakpoint(frommediumlarge) {
        padding:50px 0 62px;
      }
  
      @include breakpoint(fromgiant) {
        padding: 50px 0;
        margin-top: 75px;
        padding: 50px 30px;
        text-align:left;
      }
  
      @include breakpoint(extralarge) {
        padding: 50px 60px;
      }
  
      @include breakpoint(full) {
        padding: 50px 135px;
      }
  
      .inner-wrap {    
  
        @include breakpoint(fromgiant) {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
  
        p {
          margin-bottom: 0;
          font-size: 20px;
          line-height: 30px;
  
          @include breakpoint(fromgiant) {
            font-size: 24px;
            line-height: 32px;
          }
  
           @include breakpoint(extralarge) {
            font-size: 30px;
            line-height: 50px;
          }
  
          strong {
            display:block;
  
            @include breakpoint(frommediumlarge) {
              display:inline;
            }
          }
        }
  
        .action-block {
          padding-top:20px;
          text-align:center;
          flex-direction: column;
          display:flex;
          align-items: center;
          .btn:first-of-type {
            margin-bottom:25px;
  
            @include breakpoint(frommediumlarge) {
              margin-right: 47px;
              margin-bottom:0;
            }
          }
  
          @include breakpoint(frommediumlarge) {
            text-align:left;
            justify-content: center;
            flex-direction: row;
          }
  
          @include breakpoint(fromgiant) {
            padding-top:0;
          }
        }
      }
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/station-components/Header.vue